"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkedinIconCircleSolid = exports.LinkedinIconCircle = exports.LinkedinIconFill = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkedinIconFill = exports.LinkedinIconFill = function LinkedinIconFill() {
  return _react2.default.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
    _react2.default.createElement("path", { d: "M6.5 21.5h-5v-13h5v13zM4 6.5C2.5 6.5 1.5 5.3 1.5 4s1-2.4 2.5-2.4c1.6 0 2.5 1 2.6 2.5 0 1.4-1 2.5-2.6 2.5zm11.5 6c-1 0-2 1-2 2v7h-5v-13h5V10s1.6-1.5 4-1.5c3 0 5 2.2 5 6.3v6.7h-5v-7c0-1-1-2-2-2z" })
  );
};

var LinkedinIconCircle = exports.LinkedinIconCircle = function LinkedinIconCircle() {
  return _react2.default.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
    _react2.default.createElement("circle", { cx: "12", cy: "12", r: "11.5" }),
    _react2.default.createElement("path", { d: "M15 12.5c-.28 0-.5.22-.5.5v3.5h-3s.03-6.48 0-7h3v.83s.46-.75 1.7-.75c1.56 0 2.3 1.12 2.3 3.3v3.62h-3V13c0-.28-.23-.5-.5-.5zm-7.5-3h2v7h-2z" }),
    _react2.default.createElement("circle", { cx: "8.5", cy: "6.5", r: "1" })
  );
};

var LinkedinIconCircleSolid = exports.LinkedinIconCircleSolid = function LinkedinIconCircleSolid() {
  return _react2.default.createElement(
    "svg",
    {
      version: "1.1",
      x: "0px",
      y: "0px",
      width: "24px",
      height: "24px",
      viewBox: "0 0 24 24",
      enableBackground: "new 0 0 24 24",
      xmlSpace: "preserve"
    },
    _react2.default.createElement("path", { d: "M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12s12-5.383,12-12S18.617,0,12,0z M9.5,16.5h-2v-7h2V16.5z M8.5,7.5 c-0.553,0-1-0.448-1-1c0-0.552,0.447-1,1-1s1,0.448,1,1C9.5,7.052,9.053,7.5,8.5,7.5z M18.5,16.5h-3V13c0-0.277-0.225-0.5-0.5-0.5 c-0.276,0-0.5,0.223-0.5,0.5v3.5h-3c0,0,0.031-6.478,0-7h3v0.835c0,0,0.457-0.753,1.707-0.753c1.55,0,2.293,1.12,2.293,3.296V16.5z" })
  );
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-social-sharing/dist-modules/svg/linkedin.js
 ** module id = 1338
 ** module chunks = 0
 **/